module.exports = __webpack_public_path__ + "img/postfinance.c94929e8.png";